import { css } from "@emotion/react";

import { textBolded, textExtraLarge, textLarge, textNormal, textPrimary } from "./typography";

export const contentWrapper = css`
  padding: 30px 20px;
`;

export const imageWrapper = css`
  max-width: 480px;
  margin: 0 auto;

  img {
    max-width: 100%;
  }
`;

export const headerWrapper = css`
  padding: 40px 0 80px 0;
  text-align: center;
`;

export const header = [
  textExtraLarge,
  textBolded,
  css`
    margin-bottom: 12px;
  `,
];

export const description = [
  textLarge,
  textPrimary,
  css`
    margin-bottom: 20px;
  `,
];

export const features = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const featureBox = css`
  max-width: 250px;
  padding: 0 40px;
`;

export const featureHeader = [
  textLarge,
  textBolded,
  css`
    margin-bottom: 16px;
  `,
];

export const featureDescription = [
  textNormal,
  textPrimary,
  css`
    p {
      margin-bottom: 10px;
    }
    ul {
      list-style: disc;
      padding-left: 17px;

      li {
        text-indent: -6px;
      }
    }
  `,
];

export const buttonStyles = css`
  padding: 0 36px;
  line-height: 36px;
`;
